// DS: i4.37
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Sale: React.FC<Props> = props => (
  <IconWrap {...props} disableDefaultColors>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.63 2.27c.27-.2.7-.4.94-.16.24.22.14.59-.03.87l-4.68 5.76 3.84 4.79c.26.23.37.58.3.92l-.44 2a.97.97 0 0 1-1.05.76l-7.33-1.92.54 5.71c0 1.19-1.34 1.03-1.9.93a1.43 1.43 0 0 1-.4-.14l-7.6-3.84c-.33-.16-.62-.5-.62-.88v-.01C2.98 6.92 12.42 3.52 14.93 6.53l5.7-4.26Zm-5.17 10.2a1.1 1.1 0 1 0 0-2.18 1.1 1.1 0 0 0 0 2.19Z"
      />
    </svg>
  </IconWrap>
);
Sale.displayName = 'Sale';

export default Sale;
